(function () {
    console.log('PDP - Custom script loaded');

    const FIELD_NAME = 'properties[preorder]';
    const PREORDER_MESSAGE_EL = document.getElementById('preorder-message');
    const PREORDER_MESSAGE = PREORDER_MESSAGE_EL ? PREORDER_MESSAGE_EL.textContent.trim() : 'N.B. ARTICOLO IN PREORDER (5 settimane)';
    const MATCH_TEXTS = [
        'Questo articolo non è attualmente disponibile, può essere realizzato su misura per te e spedito in 5 settimane.',
        'This item is not currently available, can be custom made for you and shipped in 5 weeks.'
    ];

    const FORM_SELECTOR = 'form.pd-form';
    const INVENTORY_CONTAINER_SELECTOR = '[id^="Inventory-"]';
    const VARIANT_BUTTON_SELECTOR = 'label.variant-size-label';

    function log(...args) {
        console.log('[PREORDER]', ...args);
    }

    function ensureHiddenField(form) {
        let hiddenField = form.querySelector(`input[name="${FIELD_NAME}"]`);
        log('🔍 Checking for hidden field:', hiddenField);
        if (!hiddenField) {
            log('🆕 Hidden field not found, creating one');
            hiddenField = document.createElement('input');
            hiddenField.type = 'hidden';
            hiddenField.name = FIELD_NAME;
            hiddenField.value = '';
            form.appendChild(hiddenField);
            log('🆕 Hidden field created');
        }
        return hiddenField;
    }

    function removeEmptyHiddenField(form) {
        const hiddenField = form.querySelector(`input[name="${FIELD_NAME}"]`);
        if (hiddenField && hiddenField.value === '') {
            hiddenField.remove();
            log('🧹 Hidden field removed (empty)');
        }
    }

    function updateHiddenFieldValue(value) {
        const form = document.querySelector(FORM_SELECTOR);
        if (!form) {
            log('❌ Form not found');
            return;
        }
        const field = ensureHiddenField(form);
        if (field.value !== value) {
            field.value = value;
            log('✏️ Updated field value to:', value);
        } else {
            log('🟰 Field value unchanged');
        }
        // Remove the field if it's empty
        if (field.value === '') {
            removeEmptyHiddenField(form);
        }
    }

    function getInventoryText() {
        const container = document.querySelector(INVENTORY_CONTAINER_SELECTOR);
        if (!container) return '';
        const inner = container.querySelector('.product__inventory-inner');
        return inner ? inner.textContent.trim() : '';
    }

    function updateBasedOnInventory() {
        const text = getInventoryText();
        log('🔍 Inventory text:', text);
        const isPreorder = MATCH_TEXTS.some(msg => text.includes(msg));
        updateHiddenFieldValue(isPreorder ? PREORDER_MESSAGE : '');
    }

    function observeInventoryChanges() {
        const container = document.querySelector(INVENTORY_CONTAINER_SELECTOR);
        if (!container) {
            log('❌ Inventory container not found');
            return;
        }

        const observer = new MutationObserver(() => {
            log('🔁 Mutation observed in inventory');
            updateBasedOnInventory();
        });

        observer.observe(container, {
            childList: true,
            subtree: true,
        });

        log('👀 Observing inventory container');
    }

    function addClickListenersToVariantButtons() {
        const buttons = document.querySelectorAll(VARIANT_BUTTON_SELECTOR);
        buttons.forEach(btn => {
            btn.addEventListener('click', () => {
                log('👆 Variant clicked');
                // Delay to wait for DOM to update
                setTimeout(updateBasedOnInventory, 100);
            });
        });
    }

    function setupModalScrollObserver() {
        const modalElement = document.querySelector('.product-media-modal');

        if (!modalElement) {
            console.warn('[ModalScroll] ❌ .product-media-modal not found.');
            return;
        }

        const scrollOffset = 600;

        const modalObserver = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
                if (
                    mutation.type === 'attributes' &&
                    mutation.attributeName === 'open' &&
                    modalElement.hasAttribute('open')
                ) {
                    console.log('[ModalScroll] 🟢 Modal opened. Scrolling down...');
                    window.scrollBy({
                        top: scrollOffset,
                        left: 0,
                        behavior: 'smooth',
                    });
                }
            }
        });

        modalObserver.observe(modalElement, {
            attributes: true,
            attributeFilter: ['open'],
        });

        console.log('[ModalScroll] 👀 Observer attached to .product-media-modal');
    }

    function init() {
        log('🚀 Init');

        const form = document.querySelector(FORM_SELECTOR);
        if (!form) {
            log('❌ Form not found');
            return;
        }

        ensureHiddenField(form);
        updateBasedOnInventory();
        observeInventoryChanges();
        addClickListenersToVariantButtons();
        // setupModalScrollObserver();
    }

    document.addEventListener('DOMContentLoaded', init);
    window.addEventListener('pageshow', init); // When navigating back
})();
